/**
 * Copy text to the clipboard with a fallback for non-secure contexts.
 *
 * The async Clipboard API (navigator.clipboard) is only available in secure
 * contexts — https pages or localhost. When the app is served over plain http
 * on an IP (e.g. http://172.17.0.1:3000 for local dev), navigator.clipboard is
 * undefined and accessing it throws. This helper falls back to a hidden
 * textarea + document.execCommand('copy') in that case.
 *
 * @param {string} text - The text to copy.
 * @returns {Promise<boolean>} Resolves true on success, false on failure.
 */
export async function copyToClipboard(text) {
  if (text == null) return false;
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch (err) {
    // Callers surface failure to the user (error toast / no "copied" state),
    // so swallow here rather than logging to the console.
    return false;
  }
}
